import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const LegalSection = ({ title, children }) => (
    <section className="mt-12">
        <h2 className="font-display text-xl lg:text-2xl text-brand-ink mb-4">{title}</h2>
        <div className="space-y-3 font-sans text-brand-ink/70 leading-relaxed">{children}</div>
    </section>
);

export const LegalLayout = ({ title, updated, testId, children }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = `${title} — Pharmacie La Lutrive`;
    }, [title]);

    return (
        <div className="min-h-screen bg-brand-cream" data-testid={testId}>
            <Navbar />
            <main className="pt-32 pb-24 max-w-[820px] mx-auto px-6 lg:px-10">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-brand-primary mb-10 hover:underline underline-offset-4" data-testid="legal-back-link">
                    <ArrowLeft className="h-4 w-4" />
                    Retour à l'accueil
                </Link>
                <h1 className="font-display text-4xl sm:text-5xl text-brand-ink leading-tight">{title}</h1>
                <p className="mt-4 text-sm text-brand-ink/50">Dernière mise à jour : {updated}</p>
                {children}
            </main>
            <Footer />
        </div>
    );
};
